import { ReactElement } from 'react';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

const NotFoundContainer = styled.main`
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 32px 16px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

const NotFoundPage = (): ReactElement => {
  const navigate = useNavigate();

  const handleClick = () => {
    void navigate('/');
  };

  return (
    <NotFoundContainer>
      <Alert message='ページが見つかりません' description='お探しのページは存在しません' type='warning' showIcon />
      <StyledButton type='primary' onClick={handleClick}>
        ホームに戻る
      </StyledButton>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
